import { createSelector, createSelectorCreator, defaultMemoize } from 'reselect'
import { getOr, equals } from 'utils/immutable'
import { equals as equalsRamda } from 'ramda'

// helper that generates a selector one specified prop deeper than the input parentSelector, but returns null if the parent selector returned null:
export const createImmChildSelector = (parentImmSelector, childProp) =>
  createSelector(parentImmSelector, getOr(null, childProp))

// helper that does toJS but only if data was returned
export const createToJsSelector = (selector) =>
  createSelector(selector, (data) => (data && data.toJS ? data.toJS() : null))

// deep equals selector, useful for selectors that map/reduce/pick properties out of lists
// NOTE: this checks the inputs to the selector, not the result function
// https://github.com/reduxjs/reselect#createselectorcreatormemoize-memoizeoptions
export const createDeepEqualSelector = createSelectorCreator(
  defaultMemoize,
  equals
)

export const createDeepEqualSelectorMutable = createSelectorCreator(
  defaultMemoize,
  equalsRamda
)
